import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { useLenis } from '@/hooks/useLenis';

import Home from '@/pages/Home';
import DpdpaAct from '@/pages/DpdpaAct';
import SectionDetail from '@/pages/SectionDetail';
import DpdpRules from '@/pages/DpdpRules';
import RuleDetail from '@/pages/RuleDetail';
import ComplianceGuides from '@/pages/ComplianceGuides';
import ComplianceGuideDetail from '@/pages/ComplianceGuideDetail';
import Templates from '@/pages/Templates';
import ConsentManager from '@/pages/ConsentManager';
import Blog from '@/pages/Blog';
import BlogPost from '@/pages/BlogPost';
import CaseLaws from '@/pages/CaseLaws';
import News from '@/pages/News';
import Resources from '@/pages/Resources';
import EnforcementTimeline from '@/pages/EnforcementTimeline';
import SectionMapping from '@/pages/SectionMapping';
import ComplianceAssessment from '@/pages/ComplianceAssessment';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function AppContent() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dpdpa-act" element={<DpdpaAct />} />
        <Route path="/dpdpa-act/section/:id" element={<SectionDetail />} />
        <Route path="/dpdp-rules" element={<DpdpRules />} />
        <Route path="/dpdp-rules/rule/:code" element={<RuleDetail />} />
        <Route path="/compliance-guides" element={<ComplianceGuides />} />
        <Route path="/compliance-guides/:id" element={<ComplianceGuideDetail />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/consent-manager" element={<ConsentManager />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/case-laws" element={<CaseLaws />} />
        <Route path="/news" element={<News />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/enforcement-timeline" element={<EnforcementTimeline />} />
        <Route path="/resources/section-mapping" element={<SectionMapping />} />
        <Route path="/compliance-assessment" element={<ComplianceAssessment />} />
      </Routes>
      <Footer />
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  useLenis();

  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
